// app/(main)/layout.tsx
'use client';

import React from 'react';
import Footer from '@/components/Footer';
import Header from '@/components/Header';
import ScrollToTop from '@/components/Common/ScrollUp';
import { Inter } from 'next/font/google';
import '@/styles/index.css';
import { UserButton } from '@clerk/nextjs';
import { Toaster } from '@/components/ui/sonner';
import ClerkClientWrapper from '@/components/ClerkClientWrapper';

const inter = Inter({ subsets: ['latin'] });

export default function Layout({ children }: { children: React.ReactNode }) {
  return (
    <ClerkClientWrapper>
      <div className={`bg-[#FCFCFC] dark:bg-black ${inter.className}`}>
        <Header />
        <main className='grow'>{children}</main>
        <Footer />
        <ScrollToTop />
        <Toaster />
      </div>
    </ClerkClientWrapper>
  );
}
